import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { ProcessingService } from "libraries/service/processing/processing.service";
import { ILabels } from "libraries/interfaces/ILabels";
import { Yii } from "libraries/interfaces/Yii";

@Component({
    selector: 'poc-modal',
    template: `
        <card mode="bodyOnly">

            <div class="card-body-content" mat-dialog-content>
                <loader [message]="labels.loading" *ngIf="!visibleIframe"></loader>
                <iframe [attr.src]="safeUrl" (load)="showMe()" [class.visible]="visibleIframe"></iframe>
            </div>
        </card>
    `,
    styles: [`

        iframe, loader {
            width: 100%;
            border: 0;
            height: 600px;
        }
        iframe {
            display: none;
        }
        iframe.visible {
            display: block;
        }
    `]
})

export class PocModalComponent {
    public labels: ILabels = {

        loading: Yii.t('wui-sasha-js', "Chargement du POC en cours"),
    };
    public readonly url: string = "https://gallery.flutter.dev/";
    // public readonly url: string = "https://test-site-ejallier.netlify.app/";
    public readonly safeUrl: SafeResourceUrl;
    public visibleIframe: boolean;

    constructor(
        private readonly processingService: ProcessingService,
        private domSanitizer: DomSanitizer,

    ) {
        this.safeUrl = domSanitizer.bypassSecurityTrustResourceUrl(this.url);
    }

    public showMe(): void {
        this.visibleIframe = true;
    }
}
